


/**
* Quality Setting for Mentee Video
*/
export enum CanvasQuality{
    /**
    * Very Low
    */
    VeryLow = 1,
    /**
    * Low
    */
    Low = 2,
    /**
    * Average
    */
    Average = 3,
    /**
    * High - the default
    */
    High = 4,
    /**
    * Very High
    */
    VeryHigh = 5
}

